    export const TermsArray = [
      {
        title: 'tnc.tnc-1-header',
        sections: [
          {
            heading: 'tnc.tnc-a-1-title',
            points: ['tnc.tnc-a-1-desc'],
          },
          {
            heading: 'tnc.tnc-a-2-title',
            points: ['tnc.tnc-a-2-desc', 'tnc.tnc-a-2-desc'],
          },
          {
            heading: 'tnc.tnc-a-3-title',
            points: ['tnc.tnc-a-3-desc'],
          },
          {
            heading: 'tnc.tnc-a-4-title',
            points: ['tnc.tnc-a-4-desc'],
          },
        ],
      },
      {
        title: 'tnc.tnc-2-header',
        sections: [
          {
            heading: 'tnc.tnc-b-1-title',
            points: ['tnc.tnc-b-1-desc'],
          },
          {
            heading: 'tnc.tnc-b-2-title',
            points: ['tnc.tnc-b-2-desc'],
          },
          {
            heading: 'tnc.tnc-b-3-title',
            points: ['tnc.tnc-b-3-desc'],
          },
          {
            heading: 'tnc.tnc-b-4-title',
            points: ['tnc.tnc-b-4-desc'],
          },
          {
            heading: 'tnc.tnc-b-5-title',
            points: ['tnc.tnc-b-5-desc', 'tnc.tnc-b-5-desc-2'],
          },
          {
            heading: 'tnc.tnc-b-6-title',
            points: ['tnc.tnc-b-6-desc'],
          },
          {
            heading: 'tnc.tnc-b-7-title',
            points: ['tnc.tnc-b-7-desc', 'tnc.tnc-b-7-desc-2'],
          },
          {
            heading: 'tnc.tnc-b-8-title',
            points: ['tnc.tnc-b-8-desc', 'tnc.tnc-b-8-desc-2'],
          },
          {
            heading: 'tnc.tnc-b-9-title',
            points: ['tnc.tnc-b-9-desc'],
          },
        ],
      },
      {
        title: 'tnc.tnc-3-header',
        sections: [
          {
            heading: 'tnc.tnc-c-1-title',
            points: ['tnc.tnc-c-1-desc'],
            table: {
              headers: [
                'tnc.table-c-header-1',
                'tnc.table-c-header-2',
                'tnc.table-c-header-3',
              ],
              rows: [
                [
                  'tnc.table-c-row-1-col-1',
                  'tnc.table-c-row-1-col-2',
                  'tnc.table-c-row-1-col-3',
                ],
                [
                  'tnc.table-c-row-2-col-1',
                  'tnc.table-c-row-2-col-2',
                  'tnc.table-c-row-2-col-3',
                ],
                [
                  'tnc.table-c-row-3-col-1',
                  'tnc.table-c-row-3-col-2',
                  'tnc.table-c-row-3-col-3',
                ],
                [
                  'tnc.table-c-row-4-col-1',
                  'tnc.table-c-row-4-col-2',
                  'tnc.table-c-row-4-col-3',
                ],
              ],
            },
            desc: [
              'tnc.table-c-desc-1',
              'tnc.table-c-desc-2',
              'tnc.table-c-desc-3',
              'tnc.table-c-desc-4',
              'tnc.table-c-desc-5',
              'tnc.table-c-desc-6',
              'tnc.table-c-desc-7',
            ],
          },
          {
            heading: 'tnc.tnc-c-2-title',
            desc: ['tnc.tnc-c-2-subtitle-1', 'tnc.tnc-c-2-desc-1', 'tnc.tnc-c-2-subtitle-2', 'tnc.tnc-c-2-desc-2'],
          },
          {
            heading: 'tnc.tnc-c-3-title',
            desc: ['tnc.tnc-c-3-subtitle-1', 'tnc.tnc-c-3-desc-1', 'tnc.tnc-c-3-subtitle-2', 'tnc.tnc-c-3-desc-2'],
          },
          {
            heading: 'tnc.tnc-c-4-title',
            points: ['tnc.tnc-c-4-desc'],
            desc: ['tnc.tnc-c-4-subtitle-1', 'tnc.tnc-c-4-desc-1', 'tnc.tnc-c-4-subtitle-2', 'tnc.tnc-c-4-desc-2', 'tnc.tnc-c-4-subtitle-3', 'tnc.tnc-c-4-desc-3'],
          },
          {
            heading: 'tnc.tnc-c-5-title',
            points: ['tnc.tnc-c-5-desc'],
          },
          {
            heading: 'tnc.tnc-c-6-title',
            points: ['tnc.tnc-c-6-desc', 'tnc.tnc-c-6-desc-2'],
          },
        ],
      },
      {
        title: 'tnc.tnc-4-header',
        sections: [
          {
            heading: 'tnc.tnc-d-1-title',
            points: ['tnc.tnc-d-2-desc'],
          },
          {
            heading: 'tnc.tnc-d-2-title',
            points: ['tnc.tnc-d-2-desc'],
          },
          {
            heading: 'tnc.tnc-d-3-title',
            points: ['tnc.tnc-d-3-desc'],
          },
          {
            heading: 'tnc.tnc-d-4-title',
            points: ['tnc.tnc-d-4-desc'],
          }
        ]
      },
      {
        title: 'tnc.tnc-5-header',
        sections: [
          {
            points: ['tnc.tnc-e-1-desc']
          },
        ]
      },
      {
        title: 'tnc.tnc-6-header',
        sections: [
          {
            points: ['tnc.tnc-f-1-desc'],
            desc: ['tnc.tnc-f-1-desc', 'tnc.tnc-f-2-desc', 'tnc.tnc-f-3-desc', 'tnc.tnc-f-4-desc']
          },
        ],
      },
      {
        title: 'tnc.tnc-7-header',
        sections: [
          {
            points: ['tnc.tnc-g-1-desc']
          },
        ]
      },
      {
        title: 'tnc.tnc-8-header',
        sections: [
          {
            points: ['tnc.tnc-h-1-desc']
          },
        ]
      },
      {
        title: 'tnc.tnc-9-header',
        sections: [
          {
            desc: ['tnc.tnc-i-1-desc', 'tnc.tnc-i-2-desc', 'tnc.tnc-i-3-desc']
          },
        ]
      }
    ];